module.exports = __webpack_public_path__ + "img/xmjkzxt.011e6791.jpg";